module.exports = __webpack_public_path__ + "img/buscador.6a6e14da.jpg";